export default __webpack_public_path__ + "static/media/SZ10.1.896d27da.mp3";